export default "__VITE_ASSET__DLY2Paep__"